import { P2GFade } from '@parcel2go/core-ui';

interface props {
  index: number;
  children: React.ReactNode;
}
const IndexFade: React.FC<props> = (props) => (
  <P2GFade in timeout={500 + props.index * 250}>
    <>{props.children}</>
  </P2GFade>
);

export default IndexFade;
